import React from 'react';
import styled from 'styled-components';
import { OptionItem } from '../optionItem';
const GroupItemsWrapper = styled.div `
  display: grid;
  grid-template-columns: 165px 165px;
  grid-gap: 16px;
  margin: 16px 0;
`;
export const GroupOptionItems = ({ optionItems, updateOptions }) => {
    const handleSelectedItem = (id) => {
        if (updateOptions) {
            updateOptions(id);
        }
    };
    return (React.createElement(GroupItemsWrapper, null, optionItems.map(item => (React.createElement(OptionItem, { key: item.id, id: item.id, text: item.text, value: item.value, isActive: item.isActive, onClick: () => handleSelectedItem(item.id) })))));
};
//# sourceMappingURL=index.js.map